"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpirationPolicy = void 0;
const luxon_1 = require("luxon");
class ExpirationPolicy {
    constructor(partial) {
        this.rules = [];
        Object.assign(this, partial);
    }
    /**
     * Discovers an expiration policy rule that matches a
     * condition and falls within the effective date
     * @param condition Credential condition to deep match
     * @param date Date for effective date comparison often the completion date
     * @returns
     */
    findEffectiveRuleByCondition(condition, date) {
        for (const rule of this.rules.filter(r => ExpirationPolicy.isRuleEffective(r, date))) {
            const matchedCondition = rule.conditions.find((c) => {
                if (!!c.rule_value && c.rule_value !== condition.rule_value)
                    return false;
                return c.type === condition.type
                    && c.rule_system === condition.rule_system
                    && c.rule_type === condition.rule_type;
            });
            if (matchedCondition) {
                return rule;
            }
        }
        return null;
    }
    /**
     * Check if the sent date falls within a rule effective date range
     * @param rule Expiration policy rule with optional effective date range
     * @param date Date for comparison
     * @returns
     */
    static isRuleEffective(rule, date) {
        const comparisonDate = luxon_1.DateTime.fromJSDate(date);
        if (rule && rule.effective && rule.effective.start) {
            const startDate = luxon_1.DateTime.fromISO(rule.effective.start);
            if (comparisonDate < startDate) {
                return false;
            }
        }
        if (rule && rule.effective && rule.effective.end) {
            const endDate = luxon_1.DateTime.fromISO(rule.effective.end);
            if (comparisonDate > endDate) {
                return false;
            }
        }
        return true;
    }
}
exports.ExpirationPolicy = ExpirationPolicy;
